import clsx from "clsx";
import { use } from "react";

import { Ellipsis } from "../../../components/ellipsis";
import { useEditableTranscriptName } from "../../../hooks/use-editable-transcript-name";
import { TranscriptionConfiguration } from "../../../types/types";
import { TranscriptPermissionsContext } from "../transcript-permissions-provider";

interface TranscriptNameProps {
  name: string;
  id: string;
  setTranscriptionConfiguration?: React.Dispatch<
    React.SetStateAction<TranscriptionConfiguration>
  >;
}

export function TranscriptName(props: TranscriptNameProps) {
  const { name, id, setTranscriptionConfiguration } = props;
  const { transcriptPermissions } = use(TranscriptPermissionsContext);
  const {
    isEditing,
    value,
    contentRef,
    getTitleProps,
    getButtonProps,
    status,
  } = useEditableTranscriptName({
    name,
    id,
    onUpdateName:
      setTranscriptionConfiguration &&
      (() => {
        setTranscriptionConfiguration((prevTranscriptionConfiguration) => ({
          ...prevTranscriptionConfiguration,
          name: value,
        }));
      }),
  });

  return (
    <div className="m-px">
      {status === "pending" && <Ellipsis />}
      {status !== "pending" && isEditing && transcriptPermissions.edit && (
        // @ts-expect-error getTitleProps should use InputEvent
        <div
          className="w-full cursor-text rounded-lg text-left text-xl outline-none hover:ring-1 hover:ring-gray-400 focus-visible:ring-1 focus-visible:ring-cyan-600"
          ref={contentRef}
          data-testid="transcript-name"
          role="textbox"
          contentEditable
          suppressContentEditableWarning
          {...getTitleProps()}
        >
          {value}
        </div>
      )}
      {status !== "pending" && (!isEditing || !transcriptPermissions.edit) && (
        <div>
          <button
            type="button"
            className={clsx(
              "w-full max-w-full rounded-lg text-left text-xl break-words whitespace-normal outline-none",
              transcriptPermissions.edit &&
                "cursor-pointer hover:ring-1 hover:ring-gray-400",
            )}
            {...getButtonProps()}
            data-testid="transcript-name"
          >
            {value}
          </button>
        </div>
      )}
    </div>
  );
}
